export const SortTypes = {
	NameAZ: "name-az",
	CityAZ: "city-az",
	PriceHtL: "price-htl",
	PriceLtH: "price-lth",
	SqFtHtL: "sqf-htl",
	SqFtLtH: "sqf-lth",
};
